import { render, staticRenderFns } from "./dropdown-values.vue?vue&type=template&id=0ed15a99&scoped=true"
import script from "./dropdown-values.vue?vue&type=script&lang=js"
export * from "./dropdown-values.vue?vue&type=script&lang=js"
import style0 from "./dropdown-values.vue?vue&type=style&index=0&id=0ed15a99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed15a99",
  null
  
)

export default component.exports